const ShopifyIcon = require('./components/icons/shopify');
const ISetIcon = require('./components/icons/iSet');
const LinxIcon = require('./components/icons/linx');
const LojaIntegradaIcon = require('./components/icons/lojaIntegrada');
const MagentoIcon = require('./components/icons/adobecommerce');
const NuvemshopIcon = require('./components/icons/nuvemShop');
const PrestashopIcon = require('./components/icons/prestaShop');
const VtexIcon = require('./components/icons/vtex');
const WixIcon = require('./components/icons/wix');
const WoocommerceIcon = require('./components/icons/wooCommerce');
const YampiIcon = require('./components/icons/yampi');
const SalesforceIcon = require('./components/icons/salesforce');
const MercadoShopsIcon = require('./components/icons/mercadoShops');
const BigCommerce = require('./components/icons/bigcommerce');
const Tiendanube = require('./components/icons/tiendanube');

const getPlatforms = (siteId, lang) => {
  const platforms = [
    { Icon: ShopifyIcon,
      link: `/developers/${lang}/docs/shopify/landing`,
      linkMessage: 'Shopify',
      sites: ['MLA', 'MLB', 'MLC', 'MLM', 'MLU', 'MCO', 'MPE'],
      tracking: 'SHOPIFY' },
    { Icon: WoocommerceIcon,
      link: `/developers/${lang}/docs/woocommerce/introduction`,
      linkMessage: 'WooCommerce',
      sites: ['MLA', 'MLB', 'MLC', 'MLM', 'MLU', 'MCO', 'MPE'],
      tracking: 'WOOCOMMERCE' },
    { Icon: VtexIcon,
      link: `/developers/${lang}/docs/vtex/introduction`,
      linkMessage: 'VTEX',
      sites: ['MLA', 'MLB', 'MLC', 'MLM', 'MLU', 'MCO', 'MPE'],
      tracking: 'VTEX' },
    { Icon: Tiendanube,
      link: `/developers/${lang}/docs/nuvemshop/introduction`,
      linkMessage: 'Tiendanube',
      sites: ['MLA', 'MLC', 'MLM', 'MCO'],
      tracking: 'NUVEMSHOP' },
    { Icon: LojaIntegradaIcon,
      link: `/developers/${lang}/docs/loja-integrada/introduction`,
      linkMessage: 'Loja integrada',
      sites: ['MLB'],
      tracking: 'LOJA' },
    { Icon: PrestashopIcon,
      link: `/developers/${lang}/docs/prestashop/landing`,
      linkMessage: 'PrestaShop',
      sites: ['MLA', 'MLB', 'MLC', 'MLM', 'MLU', 'MCO', 'MPE'],
      tracking: 'PRESTASHOP' },
    { Icon: SalesforceIcon,
      link: `/developers/${lang}/docs/salesforce-commerce-cloud/landing`,
      linkMessage: 'COMMERCE CLOUD',
      sites: ['MLA', 'MLB', 'MLC', 'MLM', 'MLU', 'MCO', 'MPE'],
      tracking: 'SALESFORCE' },
    { Icon: WixIcon,
      link: `/developers/${lang}/docs/wix/introduction`,
      linkMessage: 'Wix',
      sites: ['MLA', 'MLB', 'MLC', 'MLM', 'MLU', 'MCO', 'MPE'],
      tracking: 'WIX' },
    { Icon: LinxIcon,
      link: `/developers/${lang}/docs/linx/introduction`,
      linkMessage: 'Linx Commerce',
      sites: ['MLB'],
      tracking: 'LINX' },
    { Icon: NuvemshopIcon,
      link: `/developers/${lang}/docs/nuvemshop/introduction`,
      linkMessage: 'Nuvemshop',
      sites: ['MLB'],
      tracking: 'NUVEMSHOP' },
    { Icon: MagentoIcon,
      link: `/developers/${lang}/docs/adobe-commerce/landing`,
      linkMessage: 'Adobe Commerce',
      sites: ['MLA', 'MLB', 'MLC', 'MLM', 'MLU', 'MCO', 'MPE'],
      tracking: 'MAGENTO' },
    { Icon: ISetIcon,
      link: `/developers/${lang}/docs/iset/introduction`,
      linkMessage: 'iSET',
      sites: ['MLB'],
      tracking: 'ISET' },
    { Icon: YampiIcon,
      link: `/developers/${lang}/docs/yampi/landing`,
      linkMessage: 'Yampi',
      sites: ['MLB'],
      tracking: 'YAMPI' },
    { Icon: BigCommerce,
      link: 'https://support.bigcommerce.com/s/article/Connecting-with-Mercado-Pago?language=en_US',
      linkMessage: 'BigCommerce',
      sites: ['MLA', 'MLB', 'MLC', 'MLM', 'MCO', 'MPE', 'MLU'],
      tracking: 'BIGCOMMERCE',
      linkBySite: {
        MLA: 'https://support.bigcommerce.com/s/article/Connecting-with-Mercado-Pago?language=es',
        MLB: 'https://support.bigcommerce.com/s/article/Connecting-with-Mercado-Pago?language=en_US',
        MLM: 'https://support.bigcommerce.com/s/article/Connecting-with-Mercado-Pago?language=es',
        MLC: 'https://support.bigcommerce.com/s/article/Connecting-with-Mercado-Pago?language=es',
        MCO: 'https://support.bigcommerce.com/s/article/Connecting-with-Mercado-Pago?language=es',
        MPE: 'https://support.bigcommerce.com/s/article/Connecting-with-Mercado-Pago?language=es',
        MLU: 'https://support.bigcommerce.com/s/article/Connecting-with-Mercado-Pago?language=es',
      },
    },
    { Icon: MercadoShopsIcon,
      linkMessage: 'Mercado Shops',
      sites: ['MLA', 'MLB', 'MLC', 'MLM', 'MCO'],
      tracking: 'MERCADOSHOPS',
      linkBySite: {
        MLA: 'https://developers.mercadolibre.com.ar/es_ar/introduccion-mshops',
        MLB: 'https://developers.mercadolivre.com.br/pt_br/introducao-mshops',
        MLM: 'https://developers.mercadolibre.com.mx/es_mx/introduccion-mshops',
        MLC: 'https://developers.mercadolibre.cl/es_cl/introduccion-mshops',
        MCO: 'https://developers.mercadolibre.com.co/es_co/introduccion-mshops',
      } },
  ];
  return platforms.filter((tool) => tool?.sites?.includes(siteId.toUpperCase()));
};

module.exports = { getPlatforms };
